import React from "react";
import { Checkbox, DefaultButton, PrimaryButton, Stack, Text, TextField } from "@fluentui/react";
import { CONTENT_TYPE_OPTIONS, MAX_CONTENT_ID_COUNT } from "../contentSummariesHelpers";

const ContentSummariesFilters = ({
    searchText,
    setSearchText,
    maxItems,
    setMaxItems,
    onlyPublished,
    setOnlyPublished,
    onlyMissingSummary,
    setOnlyMissingSummary,
    excludedTypeSlugs,
    setExcludedTypeSlugs,
    contentIdsInput,
    setContentIdsInput,
    onLoad,
    isBusy,
}) => {
    const toggleExcludedType = (typeSlug, checked) => {
        if (checked) {
            setExcludedTypeSlugs((current) => [...new Set([...(current || []), typeSlug])]);
            return;
        }

        setExcludedTypeSlugs((current) => (current || []).filter((value) => value !== typeSlug));
    };

    return (
        <>
            <Stack
                vertical
                wrap
                tokens={{ childrenGap: 16 }}
                styles={{ root: { alignItems: "flex-start" } }}
            >
                <TextField
                    label="Search title, content text, or summary"
                    value={searchText}
                    onChange={(_, value) => setSearchText(value || "")}
                    styles={{ root: { width: 360 } }}
                />
                <TextField
                    label="Max items"
                    value={maxItems}
                    onChange={(_, value) => setMaxItems(value || "")}
                    styles={{ root: { width: 120 } }}
                />
                <Stack tokens={{ childrenGap: 8 }} styles={{ root: { paddingTop: 26 } }}>
                    <Checkbox
                        label="Only published content"
                        checked={onlyPublished}
                        onChange={(_, checked) => setOnlyPublished(!!checked)}
                    />
                    <Checkbox
                        label="Only missing summaries"
                        checked={onlyMissingSummary}
                        onChange={(_, checked) => setOnlyMissingSummary(!!checked)}
                    />
                    {onlyMissingSummary && (
                        <Text variant="small" styles={{ root: { maxWidth: 280, color: "#605e5c" } }}>
                            Search is currently limited to content that does not already have a saved dbo.CONDetails.Summary value.
                        </Text>
                    )}
                    <Text variant="small" styles={{ root: { color: "#605e5c", marginTop: 8 } }}>
                        Exclude content types:
                    </Text>
                    {CONTENT_TYPE_OPTIONS.map((typeSlug) => (
                        <Checkbox
                            key={typeSlug}
                            label={typeSlug}
                            checked={(excludedTypeSlugs || []).includes(typeSlug)}
                            onChange={(_, checked) => toggleExcludedType(typeSlug, !!checked)}
                        />
                    ))}
                </Stack>
            </Stack>

            <Stack
                vertical
                wrap
                tokens={{ childrenGap: 16 }}
                styles={{ root: { alignItems: "flex-end" } }}
            >
                <TextField
                    label="Paste content IDs"
                    multiline
                    autoAdjustHeight
                    placeholder="Example: 113114, 113115 or one ID per line"
                    value={contentIdsInput}
                    onChange={(_, value) => setContentIdsInput(value || "")}
                    styles={{ root: { minWidth: 420, maxWidth: 520 } }}
                />
                <Text variant="small" styles={{ root: { maxWidth: 520, color: "#605e5c" } }}>
                    You can paste up to {MAX_CONTENT_ID_COUNT} content IDs here. If more than {MAX_CONTENT_ID_COUNT} unique IDs are entered, only the first {MAX_CONTENT_ID_COUNT} are used.
                </Text>
                <Stack
                    horizontal
                    wrap
                    tokens={{ childrenGap: 16 }}
                    styles={{ root: { alignItems: "flex-end" } }}>
                <PrimaryButton
                    text="Load Content"
                    onClick={onLoad}
                    disabled={isBusy}
                    styles={{ root: { width: "fit-content", alignSelf: "flex-start" } }}
                />
                <DefaultButton
                    text="Clear ID Filter"
                    onClick={() => setContentIdsInput("")}
                    disabled={isBusy || !contentIdsInput}
                    styles={{ root: { width: "fit-content", alignSelf: "flex-start" } }}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default ContentSummariesFilters;
